import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'

import { WorkspacePageShell } from './WorkspacePageShell'

/**
 * Members area layout: workspace shell + nested routes
 * (home, division/department/team/member detail pages).
 */
export const WorkspaceMembersSection = () => {
  const { t } = useTranslation()

  return (
    <WorkspacePageShell
      sectionTitle={t('workspace.tab.members')}
      sectionDescription={t('workspace.membersPage.sectionDescription')}
    >
      <Outlet />
    </WorkspacePageShell>
  )
}
